import { CashIcon } from "@src/assets";
import { Chain } from "@src/models";
import { memo } from "react";

type Props = {
  chain?: Chain;
  size: "small" | "medium" | "large";
};

const sizeToClassMap = {
  small: {
    icon: "w-4 h-4",
    chain: "w-2 h-2 -bottom-[1px] -right-[2px]",
  },
  medium: {
    icon: "w-6 h-6",
    chain: "w-3 h-3 -bottom-[2px] -right-[3px]",
  },
  large: {
    icon: "w-8 h-8",
    chain: "w-4 h-4 -bottom-[3px] -right-[4px]",
  },
};

const _CashLogoWithChain = ({ chain, size }: Props) => {
  const classes = sizeToClassMap[size];

  return (
    <div className="relative z-0">
      <CashIcon className={`relative z-0 ${classes.icon}`} />
      {chain?.image && (
        <img
          src={chain.image}
          alt={`${chain.name || chain.chainId}-logo`}
          className={`absolute z-10 rounded-full ${classes.chain}`}
          loading="lazy"
        />
      )}
    </div>
  );
};

export const CashLogoWithChain = memo(_CashLogoWithChain);
CashLogoWithChain.displayName = "CashLogoWithChain";
